function sendDataLayerEvent(eventName) {
    let dataLayerObject = {
        event: eventName
    }
    _sendEvent(dataLayerObject);
}

function sendPageviewEvent(location) {
    let dataLayerObject = {
        event: 'pageview',
        page: {
            path: location
        }
    }
    _sendEvent(dataLayerObject);
}

function _sendEvent(dataLayerObject) {
    dataLayer.push(dataLayerObject);
}

export {
    sendDataLayerEvent,
    sendPageviewEvent
}